import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import PortalAuthService from '../../services/PortalAuthService';
import AuthLayout from '../../components/ui/AuthLayout';
import { ADMIN_LOGIN_URL, FACILITY_HOME_URL } from '../../services/apiConfig';

const PortalLogin = () => {
    const [isLoader, setIsLoader] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (PortalAuthService.getCurrentUser()) {
            navigate('/dashboard');
        }
    }, [navigate]);

    const handleLogin = async (email, password) => {
        setIsLoader(true);
        try {
            const data = await PortalAuthService.login(email, password);
            if (data.status) {
                toast.success(data.message);
                PortalAuthService.setCurrentUser({ ...data.data.company, auth_token: data.data.auth_token });
                // Full reload so the router picks up the new session
                window.location.href = FACILITY_HOME_URL;
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            // PortalApiService already shows the error toast
        } finally {
            setIsLoader(false);
        }
    };

    return (
        <AuthLayout
            eyebrow="Partner portal"
            title="Welcome back"
            subtitle="Sign in to manage your services and bookings."
            heading="Grow your business with Helpio."
            intro="Facility management companies and service providers manage their services and customer bookings here."
            points={[
                { icon: 'bi-tools', text: 'List services with clear pricing' },
                { icon: 'bi-calendar2-check', text: 'Confirm, start and complete bookings' },
                { icon: 'bi-geo-alt', text: 'Reach residents in your service areas' },
            ]}
            onSubmit={handleLogin}
            isLoading={isLoader}
            switchLink={{ prompt: 'Helpio staff?', label: 'Admin sign in', href: ADMIN_LOGIN_URL }}
        />
    );
};

export default PortalLogin;
